import { DISCOUNT_TYPE_VALUES } from 'store/carInstance/constants';

export const getDiscount = ({ discountType, selectedVersion }) => {
  const { discount, discountDirect } = selectedVersion ?? {};

  let result = 0;

  if (discountType === DISCOUNT_TYPE_VALUES.MFR) {
    result = discount;
  } else if (discountType === DISCOUNT_TYPE_VALUES.DIRECT) {
    result = discountDirect;
  }

  if (typeof result !== 'number') {
    const number = Number(result);

    result = Number.isSafeInteger(number) ? number : 0;
  }

  return result;
};

export const getOfferPrice = ({ discount, price }) => {
  let result = price;

  if (discount > 0) {
    result -= discount;
  }

  return Math.max(0, result);
};
